import { version } from '~/../package.json'

export const app = {
  VERSION: version
}
